// @ts-ignore
import FilterFactory2 from "./lib/filter-factory-2";
import FieldProto from "../../fields3/proto/field-proto";


// I think - this one is for Fields3 while FiltersManager is for Field1

export default class FiltersManager2 {

    public module               : any
    public _onChangeCallback?   : callback
    public _allFields           : any[]
    public filters              : any[]
    public visibleFilters       : any []


    constructor(module:any, fields:FieldProto[], initValues={}, onChangeCallback?:callback) {

        this.module             = module;
        this._onChangeCallback  = onChangeCallback;
        this._allFields         = fields;
        this.filters            = [];
        this.visibleFilters     = [];

        this._initFilters(initValues);

        // update counter
        gd.bus.triggerEvent('filters-manager:counter',{counter: this.countEnabledFilters()});
    }

    _initFilters(values:any) {

        _.map(this._allFields, (field:FieldProto)=>{


            if (!field.filterType) {
                // console.log("not filter support in field", field);
                return
            }

            const FilterClass   = FilterFactory2(field.filterType)   // ,filterConfig

            // @ts-ignore
            const fieldId       = field.id ? field.id : field.fieldId   // strange ... not fieldProto ???
            const initValue     = (values && values[fieldId]) ? values[fieldId] : null

            FilterClass && this.filters.push(new FilterClass(this, field, initValue));
        })
    }

    // filters changed
    onChange(updatedFilter?:any) {
        // update counter
        gd.bus.triggerEvent('filters-manager:counter',{counter: this.countEnabledFilters()});

        // hit callbacks
        this._onChangeCallback && this._onChangeCallback();
    }

    // return array of function that will be called from Filter engine to populate options
    // for each filter
    getFilterOptionsFillerFunctions() {
        const fillerFunctions : func[] = [];

        // some filters might not have filler function i.e. number or date
        this.filters.map( filter => {
            if (filter.optionsFillerFunc) {
                fillerFunctions.push(filter.optionsFillerFunc.bind(filter));
            }
        });

        return fillerFunctions;
    }

    getFilterFunctionsUniversal() {
        const filterFunctions : func[] = [];

        this.filters.map(filter => {
            // only for enabled filters (!)
            if (filter.isEnabled) filterFunctions.push(filter.filterFuncUniversal ? filter.filterFuncUniversal.bind(filter) : filter.filterFunc.bind(filter));
        });

        return {filterFunctions};
    }

    // Count all enabled (applied) filters
    countEnabledFilters() {
        let newTotal = 0;
        this.filters.map(filter=>{
            if (filter.isEnabled) newTotal++;
        });
        return newTotal;
    }

    getPanelFieldsGrouped() {
        const displayedColumns : any[] = [];
        this.module && _.map(this.module.columns.all(), column=>{
            if (!!column.type && column.type !== 'field') return; // if type is defined and is not 'field' then it is not field
            displayedColumns.push(this.module.fields.get(column.fieldId).label)
        })

        const invisibleSystem : any[]   = [];
        const invisibleCustom : any []  = [];
        let invisibleDisplayed : any[]  = [];

        _.filter(this.filters, (filter)=>{

            if (filter.isVisible || filter.isEnabled) return;

            if (displayedColumns.includes(filter.field)) invisibleDisplayed.push(filter);
            else if (filter.isCustomField) invisibleCustom.push(filter);
            else invisibleSystem.push(filter);
        });

        // re-sort invisibleDisplayed according to displayedColumns
        invisibleDisplayed = _.sortBy(invisibleDisplayed, (filter) => {
            let filterName = filter.field;
            return displayedColumns.indexOf(filterName);
        });

        return { invisibleDisplayed, invisibleSystem, invisibleCustom };
    }

    // reset All
    resetAll() {
        this.filters.map(filter=>{
            filter.reset(true);
            if (filter.isVisible) filter.setInvisible()
        });

        // because we did it silent before
        this.onChange();
    }

    collapseAll() {this.filters.map(filter=>{filter.toggleIsOpen(false)})}
    expandAll() {this.filters.map(filter=>{filter.toggleIsOpen(true)})}

    // export current filters to object...
    toObject() {
        const result = {};
        this.filters.map(filter=>{
            // we dont need empty
            if (filter.isEnabled) { // @ts-ignore
                result[filter.field] = filter.toObject();
            }
        });
        return result;
    }

    // apply filter and ghost when needed also run when first time to inet filter options (!)
    filterItems(items:any) {
        // get array of filter conditions for filter items from filter manager
        const filterOptionsFillerFunctions = this.getFilterOptionsFillerFunctions();
        const {filterFunctions} = this.getFilterFunctionsUniversal(); //this.getFilterFunctions();

        const itemsToHide : any[] = [];

        _.map(items, item=>{
            // first fill in filter options
            _.map(filterOptionsFillerFunctions, func=>{func(item)});

            _.some(filterFunctions, func=>{
                const filterResult = func(item);
                if (!filterResult) {
                    itemsToHide.push(item.id);
                    return true;
                }
            });
        });

        return _.filter(items, item=>!itemsToHide.includes(item.id))
    }
}
